import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SFSchema } from '@delon/form';
import { IComponentDef } from '../../shared/interfaces';

@Component({
  selector: 'app-widget-config',
  templateUrl: './widget-config.component.html',
  styleUrls: ['./widget-config.component.less']
})
export class WidgetConfigComponent implements OnInit, OnChanges {
  dateArr = ['year', 'month', 'week', 'date', 'datetime', 'time', 'daterange', 'timerange', 'datetimerange', 'dates'];

  @Input() data: IComponentDef;

  @Input() defaultValues: any;

  schema2: SFSchema;

  configComponentName: string;

  constructor() {}

  ngOnInit(): void {
    console.log('');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.processorData(changes.data.currentValue);
    }
  }

  protected processorData(data: IComponentDef) {
    if (!data) {
      return;
    }
    if (typeof this.data.labelWidth !== 'number') {
      this.data.labelWidth = 100;
    }
    this.configComponentName = this.getComponent(data);
  }

  protected getComponent(data: IComponentDef) {
    return `d-${data.widget}-config`;
  }
}
